module.exports = __webpack_public_path__ + "static/media/card-img2.4de23ebb.webp";